var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { staticClass: "soli-round" },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("v-card-title", { staticClass: "header soli-grey" }, [
                _vm._v("Enrollments"),
              ]),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  items: _vm.enrollments,
                  headers: _vm.headers,
                  groupBy: "user.id",
                  "mobile-breakpoint": "0",
                  "hide-default-footer": "",
                  "disable-pagination": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `group.header`,
                      fn: function ({ group, items, isOpen, toggle }) {
                        return [
                          _c("th", { attrs: { colspan: "15" } }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-start align-center gap-6",
                              },
                              [
                                _c("v-icon", { on: { click: toggle } }, [
                                  _vm._v(
                                    _vm._s(isOpen ? "remove" : "add") +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "soli-grey font-weight-bold",
                                    staticStyle: { "font-size": "14px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(items[0].user.name) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }